<router-outlet></router-outlet>
<app-side-panel></app-side-panel>
<mua-toast-container class="relative"></mua-toast-container>
